import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './FirstRunExperiencePage.css';

const FRE_SEEN_KEY = 'quicktab_fre_seen';

export const markFreSeen = () => localStorage.setItem(FRE_SEEN_KEY, 'true');
export const hasSeenFre = () => localStorage.getItem(FRE_SEEN_KEY) === 'true';

const FirstRunExperiencePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContinue = () => {
    markFreSeen();
    navigate('/login');
  };

  const valuePoints: string[] = t('fre.valuePoints', { returnObjects: true }) as string[];

  return (
    <div className="fre-container">
      <div className="fre-card">
        <h1 className="fre-title">QuickTab</h1>
        <h2 className="fre-headline">{t('fre.headline')}</h2>
        <p className="fre-description">{t('fre.description')}</p>

        <ul className="fre-value-points">
          {valuePoints.map((point, i) => (
            <li key={i} className="fre-value-point">
              <span className="fre-check">✓</span>
              {point}
            </li>
          ))}
        </ul>

        <p className="fre-note">{t('fre.note')}</p>

        <button className="fre-primary-button" onClick={handleContinue}>
          {t('fre.continueButton')}
        </button>

        <button className="fre-skip-link" onClick={handleContinue}>
          {t('fre.skip')}
        </button>
      </div>
    </div>
  );
};

export default FirstRunExperiencePage;
